<h2 mat-dialog-title>Not Verified</h2>
<mat-dialog-content class="mat-typography">
    <p>
      We noticed that you haven't verified your email yet.
      Please verify your email first before trying to access this feature.
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>